//-- React Standard
import React, { Component, Fragment } from "react";
import { connect } from 'react-redux';
//import compose from 'recompose/compose';
import config from '../../config';
import { withStyles } from "@material-ui/core/styles";
import { apiConstants } from '../../_constants/api.constants';
import { categoryActions, productActions, userActions, tagsActions, DiscountActions } from "../../_actions";
import { commonService } from "../../_services";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import loader from '../../_assets/Ring-Loading.gif';
//import Tags from '@yaireo/tagify/dist/react.tagify';
import Select from 'react-select'

//-- CSS for Material
const styles = theme => ({
    error: {
        color: 'red',
    },
    loaderImg: {
        margin: '0 auto',
        display: 'block',
        width: '250px'
    },
    root: {
        margin: 0,
        padding: theme.spacing(2),
        backgroundColor: "#269abc",
        color: '#fff'
    },
    pageImg: {
        width: '70px',
        height: '70px',
        position: 'relative',
        padding: '10px'
    },
    removeImg: {
        position: 'absolute',
        top: '-7px',
        right: '-7px',
        padding: '0px 7px 0px 7px',
        border: '1px solid #a09d9d',
        background: '#c1c1c1',
        borderRadius: '50%',
        fontWeight: 'bold',
        cursor: 'pointer',
        color: '#fff'
    },
    borderedImg: {
        position: 'relative',
        width: '70px',
        height: '70px',
        border: '1px #dad7d7 solid',
        borderRadius: '10px',
        float: 'left',
        marginBottom: '15px',
        marginRight: '15px'
    },
    paddingClass: {
        paddingTop: '5px',
        paddingBottom: '5px'
    }, removeAttr: {
        backgroundColor: 'red',
        padding: '7px',
        borderRadius: '50%',
        paddingTop: '0px',
        paddingBottom: '2px',
        color: '#fff',
        fontWeight: 'bold',
        marginRight: '10px',
        cursor: 'pointer',
        border: '2px solid #000',
    }

});

class EditProducts extends Component {
    // tagifySettings = {
    //     blacklist: ['xxx', 'yyy', 'zzz'],
    //     maxTags: 6,
    //     backspace: "edit",
    //     addTagOnBlur: false,
    //     dropdown: {
    //         enabled: 0 // a;ways show suggestions dropdown
    //     }
    // }
    constructor(props) {
        super(props);

        this.state = {
            sort: {
                sortKey: null,
                direction: 'desc',
            },
            totalPage: '',
            totalDataCount: '',
            currentPage: 1,
            getCouponList: [],
            deleteOpen: false,
            allCategories: [],
            allSubCategories: [],
            addCat: false,
            soldIndChecked: false,
            tags: [],
            tagsToSave: [],
            attributes: [],
            selectedAttributes: [],
            selectedIndex: [],
            inputList: [],
            setInputList: [],
            addons: [],
            removedAddon: [],
            options: [],
            selectedOption: null,

        };
    }

    /*
    * componentDidMount - Initially it will call and get the advertisments data
    */
    componentDidMount() {
        const { dispatch, editProductId } = this.props;
        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = config.perPageData;

        const getproduct = {}
        getproduct.productId = editProductId;


        dispatch(productActions.getSingleProduct(apiConstants.GET_SINGLE_PRODUCT_FOR_SHOPKEEPER, getproduct));
        dispatch(categoryActions.getAllCategory(apiConstants.GET_ALL_ACTIVE_CATEGORIES_FOR_ADMIN));
        dispatch(DiscountActions.getActiveDiscountsOfShop(apiConstants.GET_ACTIVE_DISCOUNT));
        dispatch(tagsActions.getTagsAll(apiConstants.GET_ACTIVE_TAGS));
        dispatch(productActions.getAttributes(apiConstants.GET_PRODUCT_ATTRIBUTES, postData));

        let postDataSubCat = {};
        postDataSubCat.catId = '5f75b913d31224366c655d9f';

        dispatch(categoryActions.getAllSubCategory(apiConstants.GET_ALL_SUB_CATEGORIES_BY_ID_FOR_ADMIN, postDataSubCat));
    }

    // callback = (e) => {
    //     var datahold = [];
    //     e.detail.tagify.value.map((tg) => { datahold.push(tg.value); })
    //     this.setState({ tagsToSave: datahold });
    // }

    /*
    * componentWillReceiveProps - Whenever Props change, it will call and store data
    * update the state values with new props values, this method will get called whenever any change happens to props values
    */
    componentWillReceiveProps(props) {
        const { dispatch } = props;
        var oldkeys = [];
        // GET LIST OF ACTIVE CATEGORIES
        if (props.getCategories !== undefined &&
            props.getCategories.getCatList !== undefined &&
            props.getCategories.getCatList.data !== undefined &&
            props.getCategories.getCatList.data.type === "get_active_categories"
        ) {

            const catDataReceived = props.getCategories.getCatList.data;
            this.setState({
                allCategories: catDataReceived,
            })
        }

        // GET LIST OF ACTIVE SUB CATEGORIES
        if (props.getAllSubCategory !== undefined &&
            props.getAllSubCategory.getSubCatList !== undefined &&
            props.getAllSubCategory.getSubCatList.data !== undefined &&
            props.getAllSubCategory.getSubCatList.data.type === "get_sub_categories_by_id"
        ) {

            const subCatDataReceived = props.getAllSubCategory.getSubCatList.data;
            this.setState({
                allSubCategories: subCatDataReceived,
            })
        }


        // GET LIST OF ACTIVE discounts for shop
        if (props.activeDiscount) {
            if (props.activeDiscount.discGet) {
                const discRecData = props.activeDiscount.discGet;
                if (
                    discRecData.data.data
                    //discRecData.data.type === "get_active_coupon"
                ) {
                    this.setState({ getDiscountList: discRecData.data })
                }
            }
        }

        //get product details to edit
        if (props.getSingleProduct !== undefined) {
            if (
                props.getSingleProduct.Product !== undefined &&
                props.getSingleProduct.Product.data !== undefined &&
                props.getSingleProduct.Product.data.type === "get-single-product"
            ) {
                const proData = props.getSingleProduct.Product.data.productData[0];
                let selectedcatId = '';
                if (proData.categories !== null &&
                    proData.categories !== undefined
                ) {
                    selectedcatId = proData.categories._id;
                }
                let selectedSubCatId = '';
                if (proData.subCategories !== null &&
                    proData.subCategories !== undefined
                ) {
                    selectedSubCatId = proData.subCategories._id;
                }

                var dbtags = [];
                if (proData.tags !== null &&
                    proData.tags.length > 0) {
                    proData.tags.map((tgs) => {
                        dbtags.push(tgs.title);
                    })
                }
                let keysAttr = [];

                if (proData.productAttributes !== undefined && proData.productAttributes) {
                    keysAttr = Object.keys(proData.productAttributes);
                    oldkeys = keysAttr;
                }

                let selectedTags = dbtags.map(title => ({ value: title, label: title }));

                this.setState({
                    editingProdId: proData._id,
                    productTitle: proData.title,
                    productDescription: proData.description,
                    productRegularPrice: proData.regularPrice,
                    productSalePrice: proData.salePrice,
                    productMainImage_get: proData.mainImage,
                    productImageGallery_get: proData.imageGallery,
                    productCategories: selectedcatId,
                    productSubCategories: selectedSubCatId,
                    productStock: proData.inStock,
                    productSku: proData.sku,
                    productSoldIndividually: proData.productSoldIndividually,
                    costPerItem: proData.costPerItem,
                    advanceBookingAmount: proData.advance_booking_amount,
                    productBarcode: proData.barcode,
                    tagsToSave: dbtags,
                    value: dbtags,
                    selectedOption: selectedTags,
                    productDiscount: proData.discountApplied,
                    oldSelectedAttributes: proData.productAttributes,
                    oldAttrKeys: keysAttr,
                    addons: proData.addons
                });
            }
        }

        if (props.updateSingleProduct !== undefined) {
            if (props.updateSingleProduct.UpdatedProduct !== undefined &&
                props.updateSingleProduct.UpdatedProduct.data !== undefined &&
                props.updateSingleProduct.UpdatedProduct.data.type === 'product-updated') {


                if (this.state.notifyAddProduct === true) {
                    this.setState({
                        notifyAddProduct: false,
                        productTitle: '',
                        productDescription: '',
                        productRegularPrice: '',
                        productSalePrice: '',
                        productMainImage: '',
                        productImageGallery: '',
                        productCategories: '',
                        productSubCategories:'',
                        productDiscount: '',
                        productStock: '',
                        productSku: '',
                        productSoldIndividually: ''
                    });
                    props.closeEditProductPop(1);
                }
            }

        }


        //When tags list returned by servers
        if (props.allActiveTags !== undefined &&
            props.allActiveTags.activeTags !== undefined &&
            props.allActiveTags.activeTags.data !== undefined &&
            props.allActiveTags.activeTags.data.length > 0) {
            var tagsArray = props.allActiveTags.activeTags.data;
            //const whitelistFromServer = [];
            const tempWhitelistFromServer = [];

            tagsArray.map((tag) => {
               // whitelistFromServer.push(tag.title);
               tempWhitelistFromServer.push({ value: tag.title, label: tag.title });
            })

            //this.setState({ whitelist: whitelistFromServer })
            this.setState({ options: tempWhitelistFromServer })
        }


        //get all the product attributes from collection
        if (props.getProductAttributes !== undefined &&
            props.getProductAttributes.Attributes !== undefined &&
            props.getProductAttributes.Attributes.data !== undefined
        ) {
            let attribs = props.getProductAttributes.Attributes.data.data;
            this.setState({ attributes: attribs });
            var stateHold = this;

            setTimeout(function () {

                let arrDummy = [];

                attribs !== undefined && attribs.length > 0 && attribs.map((attr, index) => {
                    if (oldkeys.length > 0 && oldkeys.some(item => attr.key == item) === true) { return arrDummy.push(index); }

                })
                stateHold.setState({ selectedIndex: arrDummy });
            }, 2000);

        }
    }

    handleChangeMainImage = (e) => {
        const files = e.target.files
        let i = 0;
        let oddCntr = 0;
        let multiImageArray = [];
        var extArr = ["image/jpeg", "image/jpg", "image/png"];

        if (files.length > 1) {
            for (i = 0; i < files.length; i++) {
                //var filename = files[0].name
                if (extArr.indexOf(files[i].type) > -1) { }
                else { oddCntr++; }
                multiImageArray[i] = files[i];
            }
            if (oddCntr > 0) {
                let label = [e.target.name] + '_error';
                this.setState({ [label]: "One of the file types not suported" })
                e.target.value = null;
                this.setState({ [e.target.name]: '' })
            } else {
                this.setState({ [e.target.name]: e.target.files })
            }
        } else {
            if (extArr.indexOf(files[0].type) > -1) {
                this.setState({ [e.target.name]: files[0] })
            } else {
                let label = [e.target.name] + '_error';
                this.setState({ [label]: "One of the file type not suported" })
                e.target.value = null;
                this.setState({ [e.target.name]: '' })
            }
        }
    }

    handleChangeCheckbox = (e) => {
        let checked = 0;
        if (this.state.soldIndChecked === true) { checked = 0; }
        else { checked = 1; }
        this.setState({
            soldIndChecked: !this.state.soldIndChecked,
            [e.target.name]: checked
        })
    }

    handleChangeCategory = (e) => {
        const { dispatch } = this.props;
        let postData = {};
        postData.catId = e.target.value;

        dispatch(categoryActions.getAllSubCategory(apiConstants.GET_ALL_SUB_CATEGORIES_BY_ID, postData));
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    //save category to collection
    handleSubmit = () => {



        const { dispatch } = this.props;
        const requiredFields = [
            'productTitle',
            'productDescription',
            'productRegularPrice',
            //'productSalePrice',
            'productStock',
            'productSku',
            'costPerItem',
            'advanceBookingAmount'
        ];
        requiredFields.map((val) => {
            let lbl = [val] + '_error';
            this.setState({ [lbl]: '' });
        })
        const {
            editingProdId,
            productTitle,
            productDescription,
            productRegularPrice,
            productSalePrice,
            productMainImage,
            costPerItem,
            advanceBookingAmount,
            productMainImage_get,
            productImageGallery_get,
            productImageGallery,
            productCategories,
            productSubCategories,
            productDiscount,
            productStock,
            productSku,
            productSoldIndividually,
            productBarcode,
            tagsToSave,
            oldSelectedAttributes,
            selectedAttributes,
            addons,
            removedAddon,
            inputList

        } = this.state;

        if (productTitle === undefined || productTitle === '') { this.setState({ productTitle_error: 'Title is required' }) }
        else if (productDescription === undefined || productDescription === '') { this.setState({ productDescription_error: 'Description is required' }) }
        else if (productRegularPrice === undefined || productRegularPrice === '') { this.setState({ productRegularPrice_error: 'Regular price is required' }) }
        //else if ( productSalePrice !== undefined && parseInt(productSalePrice) > parseInt(productRegularPrice) ) { this.setState({ productSalePrice_error : 'Sale price should be less then regular price'}) }
        else if (costPerItem === undefined || costPerItem === '') { this.setState({ costPerItem_error: 'Cost per item is required' }) }
        else if (advanceBookingAmount === undefined || advanceBookingAmount === '') { this.setState({ advanceBookingAmount_error: 'Advance Amount is required' }) }
        else if (productStock === undefined || productStock === '') { this.setState({ productStock_error: 'Stock qty is required' }) }
        else if (productSku === undefined || productSku === '') { this.setState({ productSku_error: 'Stock qty is required' }) }
        else {
            this.setState({ notifyAddProduct: true });
            let featuredImage = '';
            let imgGallery = '';
            let soldInd = 0;
            if (productMainImage !== undefined && productMainImage) { featuredImage = productMainImage; }
            if (productSoldIndividually !== undefined && productSoldIndividually === 1) { soldInd = productSoldIndividually; }

            let customeFields = {};

            if (selectedAttributes.length > 0) {



                selectedAttributes.map((field, index) => {

                    if (field.type == "number") {
                        if (document.getElementsByName("number_" + index)[0].value) {
                            let fieldVal = document.getElementsByName("number_" + index)[0];
                            customeFields[fieldVal.title] = fieldVal.value;
                        }
                    }
                    if (field.type == "radio") {
                        let elements = document.getElementsByName("radio_" + index);
                        for (var i = 0, l = elements.length; i < l; i++) {
                            if (elements[i].checked) {
                                console.log(elements[i].value);
                                customeFields[elements[i].title] = elements[i].value;
                            }
                        }
                    }
                    if (field.type == "color") {
                        let fieldVal = document.getElementsByName("color_" + index)[0];
                        customeFields[fieldVal.title] = fieldVal.value;
                    }
                    if (field.type == "custom") {
                        customeFields[document.getElementsByName("label_custom_" + index)[0].value] = document.getElementsByName("value_custom_" + index)[0].value;
                    }

                });
            }

            let mergedAttributes = { ...customeFields, ...oldSelectedAttributes };


            const projData = {};
            projData.editingProdId = editingProdId;
            projData.productTitle = productTitle;
            projData.productDescription = productDescription;
            projData.productRegularPrice = productRegularPrice;
            projData.productSalePrice = productSalePrice;
            projData.advanceBookingAmount = advanceBookingAmount;
            projData.productCategories = productCategories;
            projData.productSubCategories = productSubCategories;
            projData.productDiscount = productDiscount;
            projData.productStock = productStock;
            projData.productSku = productSku;
            projData.individualSold = soldInd;
            projData.oldUpdatedAddons = addons;
            projData.removedAddon = removedAddon;
            projData.addOnList = inputList;
            if (costPerItem !== undefined) { projData.costPerItem = costPerItem; }
            if (advanceBookingAmount !== undefined) { projData.advanceBookingAmount = advanceBookingAmount; }
            
            if (productBarcode !== undefined) { projData.productBarcode = productBarcode; }
            if (tagsToSave.length > 0) { projData.tags = tagsToSave; }
            projData.productAttributes = mergedAttributes;

            const mainImageData = new FormData();
            mainImageData.append('productMainImage', featuredImage);

            commonService.withTokenAndFormData(apiConstants.SAVE_PRODUCT_MAIN_IMAGE, mainImageData).then(
                res => {
                    let mainImg = '';
                    // check if product main image is uploaded and returned by server.
                    if (res.data.data !== false) { projData.mainImg = res.data.data; }
                    else { projData.mainImg = productMainImage_get; }

                    const imageGallery = new FormData();
                    if (productImageGallery !== undefined && productImageGallery.length > 0 && productImageGallery) {
                        let loopCntr = productImageGallery.length;
                        if (loopCntr === 1) { for (let i = 0; i < loopCntr; i++) { imageGallery.append("productMainImage", productImageGallery[i]); } }
                        else {
                            for (let i = 0; i < loopCntr; i++) { imageGallery.append("productImageGallery", productImageGallery[i]); }
                        }
                    } else {
                        if (productImageGallery !== undefined) {
                            imageGallery.append("productImageGallery", productImageGallery);
                        }
                    }




                    commonService.withTokenAndFormData(apiConstants.SAVE_PRODUCT_IMAGE_GALLERY, imageGallery).then(
                        gallerydata => {

                            let imageGallery = [];

                            // check if gallery images uploaded succesfully and returned by server
                            if (
                                gallerydata.data.data !== undefined &&
                                gallerydata.data.data &&
                                gallerydata.data.data.length > 0
                            ) {
                                gallerydata.data.data.map((imgObj, index) => { imageGallery.push(imgObj.filename); })
                            }
                            if (imageGallery.length > 0) {
                                projData.imageGallery = productImageGallery_get.concat(imageGallery);
                            }
                            else {
                                projData.imageGallery = productImageGallery_get;
                            }


                            dispatch(productActions.updateProduct(apiConstants.UPDATE_PRODUCT_BY_SHOPKEEPER, projData));
                        },
                        error => { }
                    );

                },
                error => { }
            );
        }
    }

    // remove image after click from gallery
    removeFromGallery = (index) => {
        const imageData = this.state.productImageGallery_get;
        imageData.splice(index, 1);
        this.setState({ productImageGallery_get: imageData });
    }

    removeMainImage = () => {
        this.setState({ productMainImage_get: '' })
    }

    tagHandleChange = (selectedOption) => {
        this.setState({ selectedOption }, () =>
            this.state.selectedOption
        );

        var datahold = [];
        selectedOption.map((tg) => { datahold.push(tg.value); })
        this.setState({ tagsToSave: datahold });
        //this.setState({ tagsToSave: selectedOption });
    };

    //handle the change in attribute picker dropdown
    handleAttributeChange = (e) => {
        let selectedAttrHolder = [];
        let selectedindex = [];

        selectedindex = this.state.selectedIndex;
        selectedAttrHolder = this.state.selectedAttributes;

        if (e.target.value == 'custom') {
            selectedAttrHolder.push({ key: "custom", type: "custom", value: "" });
            this.setState({ selectedAttributes: selectedAttrHolder });
        }
        else {
            this.state.attributes[e.target.value].selectedIndex = e.target.value;
            selectedAttrHolder.push(this.state.attributes[e.target.value]);
            selectedindex.push(e.target.value);
            this.setState({ selectedAttributes: selectedAttrHolder, selectedIndex: selectedindex });
        }
        e.target.value = null;
    }


    // Remove attributes from holding array
    removeAttribute = (attrIndex, selIndex) => {
        let selectedAttrHolder = [];
        let selectedindex = [];

        //move old state data to array
        selectedindex = this.state.selectedIndex;
        selectedAttrHolder = this.state.selectedAttributes;

        // Remove value from the array of selected index
        selectedAttrHolder.splice(parseInt(attrIndex), 1);
        if (parseInt(selIndex) == 0 || parseInt(selIndex) > 0) {
            let indexsel = selectedindex.indexOf(selIndex);
            selectedindex.splice(parseInt(indexsel), 1);
        }

        //set final value to state
        this.setState({ selectedAttributes: selectedAttrHolder, selectedIndex: selectedindex });
    }

    //Remove old attribute valuje
    removeOldAttribute = (key) => {

        let selectedAttrHolder = [];
        let selectedindex = [];
        let mainselectedindex = this.state.selectedIndex;

        selectedAttrHolder = this.state.oldSelectedAttributes;
        selectedindex = this.state.oldAttrKeys;

        delete selectedAttrHolder[key];

        let indexsel = selectedindex.indexOf(key);
        selectedindex.splice(parseInt(indexsel), 1);

        this.state.attributes.length > 0 && this.state.attributes.map((attr, index) => {
            let indFound = false;
            if (attr.key == key) {
                let indexsel = mainselectedindex.indexOf(index);
                mainselectedindex.splice(parseInt(indexsel), 1);
            }
        });

        this.setState({
            oldSelectedAttributes: selectedAttrHolder,
            oldAttrKeys: selectedindex,
            selectedIndex: mainselectedindex
        });
    }



    //handle change and remove for already saved
    handleInputChangeOld = (e, index) => {
        const { name, value } = e.target;
        const list = [...this.state.addons];
        if (name == "add_on_label") { list[index]["addonTitle"] = value; }
        if (name == "add_on_price") { list[index]["addonPrice"] = value; }

        //setInputList(list);
        this.setState({ addons: list })
    };

    // handle click event of the Remove button
    handleRemoveClickOld = index => {
        const list = [...this.state.addons];
        const removedAddon = this.state.removedAddon;
        removedAddon.push(list[index])

        list.splice(index, 1);
        //setInputList(list);
        this.setState({ addons: list, removedAddon: removedAddon })
    };



    // handle input change
    handleInputChange = (e, index) => {
        const { name, value } = e.target;
        const list = [...this.state.inputList];
        list[index][name] = value;
        //setInputList(list);
        this.setState({ inputList: list })
    };

    // handle click event of the Remove button
    handleRemoveClick = index => {
        const list = [...this.state.inputList];
        list.splice(index, 1);
        //setInputList(list);
        this.setState({ inputList: list })
    };

    // handle click event of the Add button for add ons
    handleAddClick = () => {
        //  setInputList([...inputList, { firstName: "", lastName: "" }]);
        var inputlist = this.state.inputList;
        inputlist.push({ add_on_label: "", add_on_price: "" });
        this.setState({ inputList: inputlist })
    };


    //-- Main function
    render() {
        const { classes, displayPopUp, closeEditProductPop } = this.props;
        const { siteConstants } = this.props.language;

        // const callbacks = {
        //     add: this.callback,
        //     remove: this.callback,
        //     input: this.callback,
        //     edit: this.callback,
        //     invalid: this.callback,
        //     click: this.callback
        // }
        // const settings = {
        //     ...this.tagifySettings,
        //     callbacks: callbacks,
        //     whitelist: this.state.whitelist || []
        // }
        // const { value, showDropdown } = this.state;

        const { selectedOption } = this.state;
// console.log("SEL ",this.state.options)
        return (
            <Fragment>
                <Dialog
                    open={displayPopUp}
                    aria-labelledby="products-title"
                    aria-describedby="save-products-description"
                    fullWidth={true}
                    fullScreen={true}
                >
                    <DialogTitle className={classes.root}>{siteConstants.LABEL_EDIT_PRODUCT_POPUP}</DialogTitle>
                    <DialogContent>
                        <div class="row">

                            <div className="col-md-12 col-xs-12">
                                <div className="form-group">
                                    <label>{siteConstants.LABEL_PRODUCT_TITLE}</label>
                                    <input
                                        type="text"
                                        onChange={(e) => this.handleChange(e)}
                                        placeholder={siteConstants.LABEL_PRODUCT_TITLE_PLACEHOLDER}
                                        className="form-control"
                                        name="productTitle"
                                        value={this.state.productTitle}
                                    />
                                </div>
                                <p className={classes.error}>{this.state.productTitle_error}</p>
                            </div>

                            <div className="col-md-12 col-xs-12">
                                <div className="form-group">
                                    <label>{siteConstants.LABEL_PRODUCT_DESCRIPTION}</label>
                                    <textarea
                                        onChange={(e) => this.handleChange(e)}
                                        placeholder={siteConstants.LABEL_PRODUCT_DESCRIPTION_PLACEHOLDER}
                                        className="form-control"
                                        name="productDescription"
                                        value={this.state.productDescription}
                                    />
                                </div>
                                <p className={classes.error}>{this.state.productDescription_error}</p>
                            </div>


                            <div className="col-md-3 col-xs-6">
                                <div className="form-group">
                                    <label>{siteConstants.LABEL_PRODUCT_REGULAR_PRICE}</label>
                                    <input
                                        type="number"
                                        min="1"
                                        onChange={(e) => this.handleChange(e)}
                                        placeholder={siteConstants.LABEL_PRODUCT_REGULAR_PRICE_PLACEHOLDER}
                                        className="form-control"
                                        name="productRegularPrice"
                                        value={this.state.productRegularPrice}
                                    />
                                </div>
                                <p className={classes.error}>{this.state.productRegularPrice_error}</p>
                            </div>


                            <div className="col-md-3 col-xs-6">
                                <div className="form-group">
                                    <label>{siteConstants.LABEL_PRODUCT_SALE_PRICE}</label>
                                    <input
                                        type="number"
                                        min="0"
                                        onChange={(e) => this.handleChange(e)}
                                        placeholder={siteConstants.LABEL_PRODUCT_SALE_PRICE}
                                        className="form-control"
                                        name="productSalePrice"
                                        value={this.state.productSalePrice}
                                    />
                                </div>
                                <p className={classes.error}>{this.state.productSalePrice_error}</p>
                            </div>


                            <div className="col-md-3 col-xs-6">
                                <div className="form-group">
                                    <label>{siteConstants.LABEL_PRODUCT_COST_PER_ITEM}</label>
                                    <input
                                        type="number"
                                        min="0"
                                        onChange={(e) => this.handleChange(e)}
                                        placeholder={siteConstants.LABEL_PRODUCT_COST_PER_ITEM_LABEL}
                                        className="form-control"
                                        name="costPerItem"
                                        value={this.state.costPerItem}
                                    />
                                </div>
                                <p className={classes.error}>{this.state.costPerItem_error}</p>
                            </div>
                            <div className="col-md-3 col-xs-6">
                                <div className="form-group">
                                    <label>Advance Booking Amount(*)</label>
                                    <input
                                        type="number"
                                        min="0"
                                        onChange={(e) => this.handleChange(e)}
                                        placeholder="Advance Booking Amount"
                                        className="form-control"
                                        name="advanceBookingAmount"
                                        value={this.state.advanceBookingAmount}
                                    />
                                </div>
                                <p className={classes.error}>{this.state.advanceBookingAmount_error}</p>
                            </div>

                            <div className="col-md-6 col-xs-6">
                                <div className="form-group">
                                    <label>{siteConstants.LABEL_PRODUCT_MAIN_IMAGE}</label>
                                    <input
                                        type="file"
                                        onChange={(e) => this.handleChangeMainImage(e)}
                                        className="form-control"
                                        name="productMainImage"
                                        accept=".png,.jpg,.jpeg"
                                    />
                                </div>
                                <div className="col-md-12 col-xs-12">
                                    {
                                        this.state.productMainImage_get !== undefined &&
                                            this.state.productMainImage_get !== '' ?
                                            <div className={classes.borderedImg}>
                                                <img src={`${config.imgPath}` + '/uploads/products/' + this.state.productMainImage_get} className={classes.pageImg} />
                                                <span className={classes.removeImg} onClick={() => this.removeMainImage()}>x</span>
                                            </div>
                                            : ''
                                    }
                                </div>
                                <p className={classes.error}>{this.state.productMainImage_error}</p>
                            </div>

                            <div className="col-md-6 col-xs-6">
                                <div className="form-group">
                                    <label>{siteConstants.LABEL_PRODUCT_IMAGE_GALLERY}</label>
                                    <input
                                        type="file"
                                        onChange={(e) => this.handleChangeMainImage(e)}
                                        className="form-control"
                                        name="productImageGallery"
                                        accept=".png,.jpg,.jpeg"
                                        multiple
                                    />
                                </div>
                                <div className="col-md-12 col-xs-12">

                                    {
                                        this.state.productImageGallery_get !== undefined &&
                                        this.state.productImageGallery_get.length > 0 &&
                                        this.state.productImageGallery_get.map((img, index) => {
                                            return <div className={classes.borderedImg}>
                                                <img src={`${config.imgPath}` + '/uploads/products/' + img} className={classes.pageImg} />
                                                <span className={classes.removeImg} onClick={() => this.removeFromGallery(index)}
                                                >x</span>
                                            </div>
                                        })
                                    }
                                </div>
                                <p className={classes.error}>{this.state.productImageGallery_error}</p>
                            </div>

                            <div className="col-md-6 col-xs-6">
                                <div className="form-group">
                                    <label>{siteConstants.LABEL_PRODUCT_CATEGORY}</label>
                                    <select
                                        className="form-control"
                                        name="productCategories"
                                        onChange={(e) => this.handleChangeCategory(e)}
                                    >
                                        <option>----</option>
                                        {/* loop through all the available categories */}
                                        {
                                            this.state.allCategories !== undefined &&
                                            this.state.allCategories.data !== undefined &&
                                            this.state.allCategories.data.length > 0 &&
                                            this.state.allCategories.data.map((cat) => {
                                                let selected = false;
                                                if (cat._id === this.state.productCategories) { selected = true; }
                                                return <option value={cat._id} selected={selected}>{cat.categoryTitle}</option>
                                            })
                                        }
                                    </select>
                                </div>
                                <p className={classes.error}>{this.state.productCategories_error}</p>
                            </div>

                            <div className="col-md-6 col-xs-6">
                                <div className="form-group">
                                    <label>{siteConstants.LABEL_PRODUCT_SUB_CATEGORY}</label>
                                    <select
                                        className="form-control"
                                        name="productSubCategories"
                                        onChange={(e) => this.handleChange(e)}
                                    >
                                        <option>----</option>
                                        {/* loop through all the available categories */}
                                        {
                                            this.state.allSubCategories !== undefined &&
                                            this.state.allSubCategories.data !== undefined &&
                                            this.state.allSubCategories.data.sub_categories.length > 0 &&
                                            this.state.allSubCategories.data.sub_categories.map((cat) => {
                                                let selected = false;
                                                if (cat._id === this.state.productSubCategories) { selected = true; }
                                                return <option value={cat._id} selected={selected}>{cat.categoryTitle}</option>
                                            })
                                        }
                                    </select>
                                </div>
                                <p className={classes.error}>{this.state.productSubCategories_error}</p>
                            </div>

                            <div className="col-md-6 col-xs-6">
                                <div className="form-group">
                                    <label>{siteConstants.LABEL_PRODUCT_COUPON}</label>
                                    <select
                                        className="form-control"
                                        name="productDiscount"
                                        onChange={(e) => this.handleChange(e)}
                                    >
                                        <option>----</option>
                                        {/* loop through all the available coupon */}
                                        {
                                            this.state.getDiscountList !== undefined &&
                                            this.state.getDiscountList.data !== undefined &&
                                            this.state.getDiscountList.data.length > 0 &&
                                            this.state.getDiscountList.data.map((disc) => {
                                                return <option value={disc._id} selected={this.state.productDiscount == disc._id}>{disc.discountTitle}</option>
                                            })
                                        }
                                    </select>
                                </div>
                                <p className={classes.error}>{this.state.productDiscount_error}</p>
                            </div>

                            <div className="col-md-6 col-xs-6">
                                <div className="form-group">
                                    <label>{siteConstants.LABEL_PRODUCT_STOCK}</label>
                                    <input
                                        type="number"
                                        min="0"
                                        onChange={(e) => this.handleChange(e)}
                                        placeholder={siteConstants.LABEL_PRODUCT_STOCK_PLACEHOLDER}
                                        className="form-control"
                                        name="productStock"
                                        value={this.state.productStock}
                                    />
                                </div>
                                <p className={classes.error}>{this.state.productStock_error}</p>
                            </div>


                            <div className="col-md-6 col-xs-6">
                                <div className="form-group">
                                    <label>{siteConstants.LABEL_PRODUCT_SKU}</label>
                                    <input
                                        type="text"
                                        onChange={(e) => this.handleChange(e)}
                                        placeholder={siteConstants.LABEL_PRODUCT_SKU_PLACEHOLDER}
                                        className="form-control"
                                        name="productSku"
                                        value={this.state.productSku}
                                    />
                                </div>
                                <p className={classes.error}>{this.state.productSku_error}</p>
                            </div>

                            <div className="col-md-6 col-xs-6">
                                <div className="form-group">
                                    <label>{siteConstants.LABEL_PRODUCT_BARCODE}</label>
                                    <input
                                        type="text"
                                        onChange={(e) => this.handleChange(e)}
                                        placeholder={siteConstants.LABEL_PRODUCT_BARCODE}
                                        className="form-control"
                                        name="productBarcode"
                                        value={this.state.productBarcode}
                                    />
                                </div>
                            </div>

                            <div className="col-md-6 col-xs-6">
                                <div className="form-group">
                                    <label>{siteConstants.LABEL_PRODUCT_TAGS}</label>
                                    {/* <Tags mode='textarea' settings={settings} value={value} showDropdown={showDropdown} /> */}

                                    <Select
                                        value={selectedOption}
                                        onChange={this.tagHandleChange}
                                        options={this.state.options}
                                        isMulti
                                    />

                                </div>
                            </div>



                            {/*<div className="col-md-6 col-xs-6">
                                <div className="form-group">
                                    <label>{siteConstants.LABEL_PRODUCT_SOLD_INDIVIDUALLY}</label><br/>
                                    <input
                                        type="checkbox"
                                        onChange={(e)=>this.handleChangeCheckbox(e)}
                                        name="productSoldIndividually"
                                        checked={this.state.productSoldIndividually === 1 ? true : false }
                                    />
                                </div>
                                <p className={classes.error}>{this.state.productSoldIndividually_error}</p>
                            </div>*/}

                            <div className="col-md-12 col-xs-12">
                                <div className="form-group">
                                    <label>{siteConstants.EXTRA_ADD_ONS} &nbsp;
                                        <input type="button" onClick={() => this.handleAddClick()} value="+ Add" className="addBtn-clrd" />

                                    </label>

                                    {
                                        this.state.addons !== undefined && this.state.addons.length > 0 && this.state.addons.map((x, i) => {
                                            return (
                                                <div className="main-row-loop">
                                                    <div className="child-cross" id={i + "_addon"} onClick={() => this.handleRemoveClickOld(i)}>
                                                        x
                                                    </div>
                                                    <div className="child-half">
                                                        <input type="text" placeholder="Addon Label" name="add_on_label" value={x.addonTitle} onChange={e => this.handleInputChangeOld(e, i)} />
                                                    </div>
                                                    <div className="child-half">
                                                        <input type="number" placeholder="Addon Price" name="add_on_price" min="0" value={x.addonPrice} onChange={e => this.handleInputChangeOld(e, i)} />
                                                    </div>
                                                </div>
                                            );
                                        })
                                    }

                                    {
                                        this.state.inputList.map((x, i) => {
                                            return (
                                                <div className="main-row-loop">
                                                    <div className="child-cross" id={i + "_addon"} onClick={() => this.handleRemoveClick(i)}>
                                                        x
                                                    </div>
                                                    <div className="child-half">
                                                        <input type="text" placeholder="Addon Label" name="add_on_label" value={x.add_on_label} onChange={e => this.handleInputChange(e, i)} />
                                                    </div>
                                                    <div className="child-half">
                                                        <input type="number" placeholder="Addon Price" name="add_on_price" min="0" value={x.add_on_price} onChange={e => this.handleInputChange(e, i)} />
                                                    </div>
                                                </div>
                                            );
                                        })
                                    }

                                </div>
                            </div>

                            <div className="col-md-12 col-xs-12">
                                <div className="form-group">
                                    <label>{siteConstants.EXTRA_ATTRIBUTES}</label><br />
                                    <select
                                        className="form-control"
                                        onChange={(e) => this.handleAttributeChange(e)}
                                    >
                                        <option>---</option>
                                        {
                                            this.state.attributes.length > 0 && this.state.attributes.map((attr, index) => {
                                                let indFound = false;
                                                if (this.state.selectedIndex.some(item => index == item) === true) {
                                                    indFound = true;
                                                }
                                                return <option value={index} disabled={indFound} >{attr.key}</option>
                                            })
                                        }
                                        <option value="custom">Custom</option>
                                    </select>
                                </div>
                            </div>


                            <div className="col-md-12 col-xs-12">
                                <div className="form-group">

                                    {
                                        this.state.oldSelectedAttributes !== undefined ?
                                            (
                                                this.state.oldAttrKeys !== undefined && this.state.oldAttrKeys.length > 0 && this.state.oldAttrKeys.map((key, index) => {
                                                    if (key == "color") {
                                                        return <div className={classes.paddingClass + " row"}>
                                                            <div className="col-md-6 col-xs-6">
                                                                <span className={classes.removeAttr} onClick={(e) => this.removeOldAttribute(key)}>x</span>
                                                                <label>{key}</label>
                                                            </div>
                                                            <div className="col-md-6 col-xs-6">
                                                                <input type="color" name="color" title="color" value={this.state.oldSelectedAttributes[key]} disabled="true" />
                                                            </div>
                                                        </div>
                                                    }
                                                    else {
                                                        return <div className={classes.paddingClass + " row"}>
                                                            <div className="col-md-6 col-xs-6">
                                                                <span className={classes.removeAttr} onClick={(e) => this.removeOldAttribute(key)}>x</span>
                                                                <label>{key}</label>
                                                            </div>
                                                            <div className="col-md-6 col-xs-6">
                                                                <input type="text" name={key} title={key} value={this.state.oldSelectedAttributes[key]} disabled="true" />
                                                            </div>
                                                        </div>
                                                    }
                                                })
                                            )
                                            : ''
                                    }

                                    {
                                        this.state.selectedAttributes !== undefined && this.state.selectedAttributes.length > 0 ?
                                            (
                                                this.state.selectedAttributes.map((field, index) => {

                                                    //if field is a color type
                                                    if (field.type === 'color') {
                                                        let fieldName = 'color_' + index;
                                                        return <div className={classes.paddingClass + " row"}>
                                                            <div className="col-md-6 col-xs-6">
                                                                <span className={classes.removeAttr} onClick={(e) => this.removeAttribute(index, field.selectedIndex)}>x</span>
                                                                <label>{field.key}</label>
                                                            </div>
                                                            <div className="col-md-6 col-xs-6">
                                                                <input type={field.type} id={fieldName} name={fieldName} title={field.key} />
                                                            </div>
                                                        </div>
                                                    }

                                                    //if field is a radio btn type
                                                    if (field.type === 'radio') {
                                                        return <div className={classes.paddingClass + " row"}>
                                                            <div className="col-md-6 col-xs-6">
                                                                <span className={classes.removeAttr} onClick={(e) => this.removeAttribute(index, field.selectedIndex)}>x</span>
                                                                <label>{field.key}</label>
                                                            </div>
                                                            <div className="col-md-6 col-xs-6">
                                                                {
                                                                    field.value.length > 0 && field.value.map((innerRadio) => {
                                                                        let fieldName = 'radio_' + index;
                                                                        return (
                                                                            <span>
                                                                                <input type="radio" value={innerRadio} name={fieldName} title={field.key} /> {innerRadio} &nbsp;
                                                                            </span>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                    }
                                                    //if field is a number field
                                                    if (field.type === 'number') {
                                                        let fieldName = 'number_' + index;
                                                        return <div className={classes.paddingClass + " row"}>
                                                            <div className="col-md-6 col-xs-6">
                                                                <span className={classes.removeAttr} onClick={(e) => this.removeAttribute(index, field.selectedIndex)}>x</span>
                                                                <label>{field.key}</label>
                                                            </div>
                                                            <div className="col-md-6 col-xs-6">
                                                                <input type={field.type} name={fieldName} title={field.key} />
                                                            </div>
                                                        </div>
                                                    }

                                                    if (field.type === 'custom') {
                                                        let fieldName = 'label_custom_' + index;
                                                        let valuedName = 'value_custom_' + index;
                                                        return <div className={classes.paddingClass + " row"}>
                                                            <div className="col-md-6 col-xs-6">
                                                                <span className={classes.removeAttr} onClick={(e) => this.removeAttribute(index, field.selectedIndex)}>x</span>
                                                                <input type={field.type} name={fieldName} placeholder="Title" />
                                                            </div>
                                                            <div className="col-md-6 col-xs-6">
                                                                <input type={field.type} name={valuedName} placeholder="Value" />
                                                            </div>
                                                        </div>
                                                    }



                                                })
                                            )
                                            :
                                            ('')
                                    }
                                </div>
                            </div>


                        </div>

                    </DialogContent>


                    <DialogActions>
                        <Button variant="contained" onClick={() => closeEditProductPop(0)}>{siteConstants.LABEL_CANCEL}</Button>
                        <Button variant="contained" color="primary" onClick={(e) => this.handleSubmit(e)}>{siteConstants.LABEL_SAVE}</Button>
                    </DialogActions>
                </Dialog>

                {/* notify saving data */}
                <Dialog open={this.state.notifyAddProduct} aria-labelledby="save-product-notify" >
                    <DialogTitle>{siteConstants.LABEL_SAVING_PRODUCT_DATA}</DialogTitle>
                    <img className={classes.loaderImg} src={loader} />
                </Dialog>


            </Fragment>
        );
    }
}


//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { language,
        saveProduct,
        getCategories,
        getAllSubCategory,
        getCategory,
        getCoupounList,
        getSingleProduct,
        updateSingleProduct,
        allActiveTags,
        getProductAttributes,
        activeDiscount } = state;
    return {
        language,
        saveProduct,
        getCategories,
        getAllSubCategory,
        getCategory,
        getCoupounList,
        getSingleProduct,
        updateSingleProduct,
        allActiveTags,
        getProductAttributes,
        activeDiscount
    };
}
export default connect(mapStateToProps)(withStyles(styles)(EditProducts))
